import React from 'react';

export const CleanlinessRightPanel = ({ data }) => {
  return (
    <>
      <p className="spec-title">TURBIDITY</p>
      <p className="spec-value">{data.turbidity}</p>
    </>
  );
};